import camelize from 'camelcase-keys-deep';

export default class Approval {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  user() {
    return this.env().Entity.findBy('userId', this.userId);
  }
}
